import { ModuleType } from '../shared/types/module-type';
import { ICreateChangeBase } from '@fi-shared/models/models';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';

export interface IExtendedRoleRightModel extends ICreateChangeBase {
    Id: number;
    Name: string;
    Description: string;
    Names: IContentLanguageLabelModel[];
    Descriptions: IContentLanguageLabelModel[];
    BaseRoleId: number;
    ExtendedShareRoleIds: number[];
    ExtendedAccessRoleIds: number[];
    ShareToAll: boolean;
    HasAccessToAll: boolean;
}

export class ExtendedRoleRightModel implements ICreateChangeBase {
    Id = 0;
    Name = '';
    Description = '';
    BaseRoleId = undefined;
    Names = [];
    Descriptions = [];

    CreatedByUserId = 0;
    CreatedByUserName = '';
    CreatedOn: string; //ISO 8601 date
    ChangedByUserId = 0;
    ChangedByUserName = '';
    ChangedOn: string; //ISO 8601 date

    ShareToAll = false; // share to all areas AND business areas
    HasAccessToAll = false; // access to all business areas ONLY (access to all areas have our organization global admins)

    ExtendedShareRoleIds: number[] = [];
    ExtendedAccessRoleIds: number[] = [];

    ModuleType: ModuleType;

    constructor(moduleType: ModuleType, initializeItem?: IExtendedRoleRightModel) {
        this.ModuleType = moduleType;
        if (initializeItem) this.initialize(initializeItem);
    }

    private initialize(extendedRoleRight: IExtendedRoleRightModel) {
        this.Id = extendedRoleRight.Id;
        this.Name = extendedRoleRight.Name;
        this.Description = extendedRoleRight.Description;

        this.CreatedByUserId = extendedRoleRight.CreatedByUserId;
        this.CreatedByUserName = extendedRoleRight.CreatedByUserName;
        this.CreatedOn = extendedRoleRight.CreatedOn;
        this.ChangedByUserId = extendedRoleRight.ChangedByUserId;
        this.ChangedByUserName = extendedRoleRight.ChangedByUserName;
        this.ChangedOn = extendedRoleRight.ChangedOn;

        this.BaseRoleId = extendedRoleRight.BaseRoleId;

        this.ShareToAll = extendedRoleRight.ShareToAll;
        this.HasAccessToAll = extendedRoleRight.HasAccessToAll;

        this.ExtendedShareRoleIds = extendedRoleRight.ExtendedShareRoleIds;
        this.ExtendedAccessRoleIds = extendedRoleRight.ExtendedAccessRoleIds;
    }
}
